import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	constructor() {}

	public signInAnonymously() {
		return firebase.auth().signInAnonymously();
	}

	public onAuthStateChanged(cb) {
		return firebase.auth().onAuthStateChanged(cb);
	}
}
